import isEmpty from 'lodash-es/isEmpty'

import {
  CALENDAR_SETTINGS_FIELD_NAME_DAILY_LIMIT,
  CALENDAR_SETTINGS_FIELD_NAME_DEFAULT_REMINDER,
  CALENDAR_SETTINGS_FIELD_NAME_SENDER_MAIL_ACCOUNT,
  CALENDAR_SETTINGS_FIELD_NAME_SHOW_PROVIDER_TASKS,
  CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES,
  CALENDAR_SETTINGS_SENDER_OPTION_SEPARATOR,
} from './CalendarSettings.constants'

function toCalendarSettingsSenderOption({ description, email, id }) {
  return {
    label: [email, description]
      .filter(Boolean)
      .join(CALENDAR_SETTINGS_SENDER_OPTION_SEPARATOR),
    value: id,
  }
}

export function getCalendarSettingsTaskTypeFieldName(type) {
  return `${CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES}.${type.id}`
}

export function getCalendarSettingsInitialValues(settings) {
  return {
    [CALENDAR_SETTINGS_FIELD_NAME_DAILY_LIMIT]:
      settings[CALENDAR_SETTINGS_FIELD_NAME_DAILY_LIMIT],
    [CALENDAR_SETTINGS_FIELD_NAME_DEFAULT_REMINDER]:
      settings[CALENDAR_SETTINGS_FIELD_NAME_DEFAULT_REMINDER],
    [CALENDAR_SETTINGS_FIELD_NAME_SENDER_MAIL_ACCOUNT]:
      settings[CALENDAR_SETTINGS_FIELD_NAME_SENDER_MAIL_ACCOUNT],
    [CALENDAR_SETTINGS_FIELD_NAME_SHOW_PROVIDER_TASKS]:
      settings[CALENDAR_SETTINGS_FIELD_NAME_SHOW_PROVIDER_TASKS],
    [CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES]: Object.fromEntries(
      settings[CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES].map(type => [
        type.id,
        type.calendar_relevant,
      ])
    ),
  }
}

export function getCalendarSettingsPayload({ settings, values }) {
  return {
    [CALENDAR_SETTINGS_FIELD_NAME_DAILY_LIMIT]:
      values[CALENDAR_SETTINGS_FIELD_NAME_DAILY_LIMIT],
    [CALENDAR_SETTINGS_FIELD_NAME_DEFAULT_REMINDER]:
      values[CALENDAR_SETTINGS_FIELD_NAME_DEFAULT_REMINDER],
    [CALENDAR_SETTINGS_FIELD_NAME_SENDER_MAIL_ACCOUNT]:
      values[CALENDAR_SETTINGS_FIELD_NAME_SENDER_MAIL_ACCOUNT],
    [CALENDAR_SETTINGS_FIELD_NAME_SHOW_PROVIDER_TASKS]:
      values[CALENDAR_SETTINGS_FIELD_NAME_SHOW_PROVIDER_TASKS],
    [CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES]: settings[
      CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES
    ].map(type => ({
      ...type,
      calendar_relevant:
        values[CALENDAR_SETTINGS_FIELD_NAME_TASK_TYPES][type.id],
    })),
  }
}

export function getCalendarSettingsSenderOptions({ options, t }) {
  return [
    { label: t('CalendarSettings.SenderSystemKey'), value: null },
    ...options.map(toCalendarSettingsSenderOption),
  ]
}

export function isCalendarSettingsSenderListEmpty(options) {
  return isEmpty(options)
}
